/* Capture artwork inquiries while preserving Shopify's native contact delivery. */
(() => {
  if (window.studioInquiryCaptureLoaded) return;
  window.studioInquiryCaptureLoaded = true;
  const endpoint = 'https://studio-e-opportunities.dan-c0f.workers.dev/api/website-inquiry';
  const storageKey = 'studio-e-pending-inquiry-v1';
  const inFlight = new Map();
  const pending = () => {
    try { const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); if (value?.payload?.id && value.expires > Date.now()) return value.payload; sessionStorage.removeItem(storageKey); } catch { /* Native contact delivery remains available. */ }
    return null;
  };
  const send = payload => {
    if (inFlight.has(payload.id)) return inFlight.get(payload.id);
    const job = (async () => {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 4500);
      try {
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal, credentials: 'omit', keepalive: true });
        if (!response.ok) throw new Error('Inquiry capture pending.');
        try { if (pending()?.id === payload.id) sessionStorage.removeItem(storageKey); } catch { /* Preserve native delivery. */ }
      } finally { clearTimeout(timer); }
    })().finally(() => inFlight.delete(payload.id));
    inFlight.set(payload.id, job); return job;
  };
  const retry = () => { const payload = pending(); if (payload) void send(payload).catch(() => {}); };
  // Loaded globally so Shopify's contact-success page can retry an interrupted capture.
  retry(); window.addEventListener('online', retry);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') retry(); });
  const form = document.getElementById('seg-inquire-form');
  if (!form || form.dataset.opportunityBound) return;
  form.dataset.opportunityBound = 'true';
  form.addEventListener('submit', () => {
    let reference = form.querySelector('[name="contact[Inquiry reference]"]');
    if (!reference) { reference = document.createElement('input'); reference.type = 'hidden'; reference.name = 'contact[Inquiry reference]'; form.append(reference); }
    if (!reference.value) reference.value = crypto.randomUUID();
    const fields = new FormData(form), product = window.meta?.product || window.ShopifyAnalytics?.meta?.product;
    const payload = { id: reference.value, name: fields.get('contact[name]') || '', email: fields.get('contact[email]') || '', phone: fields.get('contact[phone]') || '', message: fields.get('contact[body]') || '', productId: form.dataset.opportunityProduct || product?.gid || (product?.id ? 'gid://shopify/Product/' + product.id : ''), artwork: form.dataset.opportunityTitle || fields.get('contact[Artwork]') || '', page: location.origin + location.pathname };
    try { sessionStorage.setItem(storageKey, JSON.stringify({ payload, expires: Date.now() + 30 * 60 * 1000 })); } catch { /* Preserve native form delivery. */ }
    void send(payload).catch(() => { /* The global capture script retries after native contact delivery. */ });
  }, true);
})();
